import { makeStyles } from "@material-ui/core";
import brandTheme from "brandTheme/Theme";
import React from "react";

const useStyles = makeStyles((theme) => ({
  container: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    width: "92%",
    maxWidth: "1000px",
    margin: "0 auto",
    minHeight: "85vh",
    overflow: "hidden",
    padding: theme.spacing(3, 0),

    "@media (max-width: 768px)": {
      width: "95%",
      padding: theme.spacing(2, 0),
    },
  },

  content: {
    flexGrow: 1,
    overflowY: "auto",
    padding: theme.spacing(1, 2, 4),

    "&::-webkit-scrollbar": {
      width: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      background: "#d4d4d4",
      borderRadius: 6,
    },
  },

  title: {
    fontSize: 32,
    fontWeight: 700,
    color: "#15254F",
    marginBottom: theme.spacing(3),
    textAlign: "center",

    "@media (max-width: 600px)": {
      fontSize: 26,
    },
  },

  section: {
    marginBottom: theme.spacing(4),
  },

  heading: {
    fontSize: 20,
    fontWeight: 600,
    color: "#15254F",
    marginBottom: theme.spacing(1.5),
    borderLeft: "4px solid #1CB167",
    paddingLeft: theme.spacing(1.5),
  },

  paragraph: {
    fontSize: 15,
    lineHeight: 1.8,
    color: "#555",
    marginBottom: theme.spacing(2),
  },

  list: {
    margin: 0,
    paddingLeft: theme.spacing(3),

    "& li": {
      fontSize: 15,
      lineHeight: 1.8,
      color: "#555",
      marginBottom: theme.spacing(1),
    },
  },

  footer: {
    textAlign: "end",
    padding: theme.spacing(2),
    background: "#fff",
    position: "sticky",
    bottom: 0,
    borderTop: "1px solid #E5E5E5",
    zIndex: 10,
  },

  nextButton: {
    boxShadow: "inherit",
    color: brandTheme.white,
    padding: "0 40px",
    height: 50,
    minWidth: 140,
    borderRadius: 8,
    textTransform: "none",
    fontWeight: 600,
    background:
      "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",

    "&:hover": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },

    "&:focus": {
      background:
        "linear-gradient(135deg, #15254F 0%, #1CB167 50%, #28D17F 100%)",
      boxShadow: "inherit",
    },

    "@media (max-width: 600px)": {
      width: "100%",
    },
  },
}));
const TermsAndConditions = () => {
      const classes = useStyles();
  return (
    <div className={classes.container}>
      <h1 className={classes.title}>Terms & Conditions</h1>

      <p>
        These Terms and Conditions govern your use of Aryaman loan services. By
        applying for a loan with Aryaman, you agree to comply with and be bound
        by these Terms.
      </p>

      <section>
        <h2 className={classes.heading}>Eligibility</h2>
        <ul className={classes.list}>
          <li>Applicants must be between 21 and 60 years of age.</li>
          <li>
            Applicants must be either salaried employees or self-employed with a
            stable income.
          </li>
          <li>Minimum monthly income: ₹25,000 is required.</li>
          <li>A good credit history is preferred but not mandatory.</li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Terms</h2>
        <ul className={classes.list}>
          <li>
            Repayment terms range from 2 to 60 months, depending on the loan
            type.
          </li>
          <li>
            Monthly installments must be paid on or before the due date
            specified in the loan agreement.
          </li>
          <li>
            Late payments may incur additional charges as outlined in the loan
            agreement.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Interest Rates & Fees</h2>
        <ul className={classes.list}>
          <li>
            All fees and charges will be clearly communicated upfront, with no
            hidden costs.
          </li>
          <li>
            Processing fees, prepayment charges, and late payment penalties, if
            any, will be detailed in the loan agreement.
          </li>
          <li>
            Interest rates vary based on the loan type and the applicant’s
            creditworthiness.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Application Process</h2>
        <ol>
          <li>
            Application: Complete the online application form on our website or
            mobile app.
          </li>
          <li>
            Documentation: Submit all required documents for verification,
            including proof of identity, proof of address, income proof, and a
            recent photograph.
          </li>
          <li>
            Approval: Aryaman will review the application and notify you of the
            approval status within 48 hours.
          </li>
          <li>
            Disbursement: Upon approval, the loan amount will be disbursed
            directly to your bank account.
          </li>
        </ol>
      </section>

      <section>
        <h2 className={classes.heading}>Repayment</h2>
        <p>
          Processing fees, prepayment charges, and late payment penalties, if
          any, will be detailed in the loan agreement.
        </p>
      </section>

      <section>
        <h2 className={classes.heading}>Prepayment & Foreclosure</h2>
        <ul className={classes.list}>
          <li>You may prepay the loan in full or part before the due date.</li>
          <li>
            Prepayment charges, if any, will be detailed in the loan agreement.
          </li>
          <li>
            Foreclosure of the loan is subject to the terms specified in the
            loan agreement.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Default & Recovery</h2>
        <ul className={classes.list}>
          <li>
            In case of default, Aryaman reserves the right to take appropriate
            legal action to recover the outstanding amount.
          </li>
          <li>
            Defaulting on the loan may impact your credit score and future
            borrowing ability.
          </li>
          <li>
            Aryaman may employ ethical recovery practices and adhere to all
            regulatory guidelines.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Refund Policy</h2>
        <p>
          We do not offer any Refunds. Please note that our company does not
          charge any fees prior to loan disbursement. Accordingly, no refunds
          are applicable, as no upfront payments are collected at any stage of
          the loan process.
        </p>
      </section>

      <section>
        <h2 className={classes.heading}>Privacy & Security</h2>
        <ul className={classes.list}>
          <li>
            All data collected during the loan application process will be used
            by our Privacy Policy.
          </li>
          <li>
            We employ advanced security measures to ensure the confidentiality
            and integrity of your data.
          </li>
          <li>
            Aryaman is committed to protecting your personal and financial
            information.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Amendments</h2>
        <ul className={classes.list}>
          <li>Aryaman reserves the right to amend these Terms at any time.</li>
          <li>
            Any changes will be communicated to you through our website, mobile
            app or via email.
          </li>
          <li>
            Continued use of our services after any such amendments signifies
            your acceptance of the new Terms.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Registration</h2>
        <p>
          Our website and mobile app offers the flexibility for individuals to
          access it either as guests or by registering for an account. While
          basic features are accessible to all, certain sections are reserved
          exclusively for registered users. To register, eligible customers are
          required to fill out all necessary information proactively. This
          includes personal details and other relevant data.
        </p>
        <p>
          Upon applying for registration, users grant consent for our platform
          to conduct various verifications and checks. These may encompass
          identity verification, Know Your Customer (KYC) procedures, fraud
          checks, credit score assessments, and employment, home or business
          place verification.
        </p>
        <p>
          It’s imperative to note that providing accurate, updated, or
          incomplete information during registration could suspend or
          permanently terminate the user account. In such instances, the website
          and mobile app reserves the right to refuse any current or future use
          of its services. Furthermore, users are expected to furnish specific
          personal information during the registration process. By doing so,
          they explicitly authorize the website or mobile app to access,
          collect, and retain their data under our privacy policies.
          Registration on our platform is entirely free of charge for anyone
          interested in joining. Moreover, individuals seeking a personal loan
          through our website or mobile app can rest assured that there are no
          processing fees associated with the application process.
        </p>
      </section>
      <section>
        <h2 className={classes.heading}>Use</h2>
        <p>
          To apply for a short-term personal loan through our LoanBuzz platform,
          you must first log in to your LoanBuzz account. All registered users
          on our website or mobile app are solely responsible for any activities
          associated with their account. The operators of the website and mobile
          app are not liable for any criminal operations, including misuse,
          unauthorized access, or hacking of the site. All users must confirm
          and acknowledge that they have received a copy of the credit agreement
          between the lender and borrower. Users must also confirm that they
          have read and understood all the terms and conditions stated in the
          Loan Agreement and agree to abide by them. If a user suspects that
          their personal information provided for their LoanBuzz account is
          being misused or hacked, they should immediately notify the site.
        </p>
        <p>
          We reserve the right to refuse to act on any instructions received
          from a user if we believe:
        </p>
        <ul className={classes.list}>
          <li>the instructions are not provided by a registered user.</li>
          <li>the user is confused.</li>
          <li>the instructions could lead to a violation of regulations.</li>
          <li>
            the instructions suggest that the site is being misused for criminal
            activity.
          </li>
        </ul>
        <p>
          Any unauthorized access to our site by a user will result in temporary
          or permanent termination of site access.
        </p>
        <p>
          Users are prohibited from saving, downloading, or printing any content
          from the site for unauthorized commercial gain.
        </p>
        <p>
          The website and mobile app reserves the right to deny or cancel user
          registration and to ban any individual from accessing the site
          temporarily or permanently for specific reasons.
        </p>
      </section>
      <section>
        <h2 className={classes.heading}>PROCEDURE</h2>
        <ul className={classes.list}>
          <li>
            Selection of Borrower Profiles: When a lender decides to extend a
            loan, they have the flexibility to choose one or multiple borrower
            profiles from the diverse pool of borrowers listed on our platform.
          </li>
          <li>
            Timely Loan Initiation: Upon selecting a borrower, the lender
            commits to initiating the principal loan offer within the initial
            thirty days from their registration date on our site.
          </li>
          <li>
            Smooth Fund Transfer: Following borrower acceptance, the registered
            lender can seamlessly transfer an amount equivalent to the requested
            loan sum with minimal deviation, ensuring swift and efficient
            transaction processing.
          </li>
          <li>
            Formal Agreement: It is mandatory for both the borrower and lender
            to establish a comprehensive agreement, delineating the terms and
            conditions of the loan. This ensures mutual understanding and
            clarity throughout the lending process.
          </li>
          <li>
            Secure Fund Disbursement: Upon agreement, the approved individual
            loan amount will be securely debited from the borrower’s designated
            bank account, facilitating a secure and transparent transaction
            experience for all parties involved.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Loan Approval Requirements</h2>
        <ul className={classes.list}>
          <li>
            Acceptance of the approved loan amount by the borrower is mandatory.
          </li>
          <li>
            Consent to credit score verification through the Credit Information
            Bureau.
          </li>
          <li>
            Borrowers must provide any additional information necessary for
            credit processing.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>TERMS FOR BORROWING</h2>
        <ul className={classes.list}>
          <li>
            Application Process: Borrowers qualify to request a personal loan by
            submitting their requirements and completing the application process
            on our site.
          </li>
          <li>
            Bank Account Details: During registration, borrowers must provide
            complete information about their bank account for repayment
            purposes.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Administration of Loan</h2>
        <ul className={classes.list}>
          <li>
            EMI Payments: EMIs commence from the loan repayment date, with
            interest accruing five days after the investment or loan payment
            date, whichever is earlier.
          </li>
          <li>
            Missed Payments: In case of missed repayments, borrowers must notify
            the company via email and describe the delay charges, inform the
            lender, and address any potential reporting to CIBIL for payment
            default.
          </li>
          <li>
            Default Classification: Borrowers may be classified as defaulters if
            they fail to make three consecutive payments, in the event of the
            borrower’s death, or if they are unable to make further repayments
            for any reason.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Settlements</h2>
        <ul className={classes.list}>
          <li>
            Fee Charges: Any received funds from the borrower may include delay
            charges, late fees, or punitive charges of any nature.
          </li>
          <li>
            Account Records: These charges are recorded in the lender’s Aryaman
            account, accessible by logging into registered user accounts.
          </li>
          <li>
            Reimbursement Management: All collected repayments are transferred
            to the lender’s Aryaman account, with the balance reflecting
            received EMIs on time. However, it may take up to 3 days for the EMI
            receipt to reflect in the borrower’s Aryaman account.
          </li>
        </ul>
      </section>
      <section>
        <h2 className={classes.heading}>Closing Your LoanBuzz Account</h2>
        <ul className={classes.list}>
          <li>
            Account Closure by User: Upon completion of all loan repayments,
            users may opt to close their loan account by sending an email
            request to us.
          </li>
          <li>
            Account Termination by LoanBuzz: We reserve the right to terminate
            the enrollment of a loan account if incorrect or incomplete
            information is provided, or if the terms of use are violated.
            Additionally, accounts may be terminated if we receive confirmation
            of the borrower’s demise.
          </li>
          <li>
            Termination for Fraudulent Activities: We also reserve the right to
            terminate accounts if fraudulent activities are detected or if users
            engage in activities detrimental to the reputation or interests of
            our site.
          </li>
        </ul>
      </section>
      <section>
        <h2 className={classes.heading}>Content Usage</h2>
        <ul className={classes.list}>
          <li>
            Content Guidelines: Users are prohibited from engaging in any
            activity that involves displaying, hosting, modifying, uploading,
            broadcasting, publishing, sharing, or updating any information that:
            a. Belongs to another person. b. Is harassing, defamatory, obscene,
            explicit, vulgar, or invasive of another person’s privacy. c. Harms
            minors in any way. d. Poses a threat to the integrity, unity,
            sovereignty, or security of India.
          </li>
        </ul>
      </section>
      <section>
        <h2 className={classes.heading}>Information Protection And Privacy</h2>
        <ul className={classes.list}>
          <li>
            Communication Channels: We send service communications to registered
            mobile numbers and email IDs, which are automated and cannot be
            opted out of.
          </li>
          <li>
            Optional Updates: Users registered with Aryaman have the option to
            receive periodic updates from the company, based on their approval.
          </li>
        </ul>
      </section>

      <section>
        <h2 className={classes.heading}>Intellectual Property Rights</h2>
        <p>
          Ownership of Content: All rights of the website and mobile app owners
          are reserved under Intellectual Property Rights (IPR). Under no
          circumstances should any content be copied or reproduced without
          authorization.
        </p>
      </section>
    </div>
  );
};

export default TermsAndConditions;
